"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TemplateCarouselSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _index2 = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _TemplateItem = _interopRequireDefault(require("./TemplateItem.js"));
var _SlideControlButtons = _interopRequireDefault(require("./SlideControlButtons.js"));
var _TemplateModal = _interopRequireDefault(require("./TemplateModal.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

const TemplateCarousel = /*#__PURE__*/(0, _react2.styled)("article")({
  name: "TemplateCarousel",
  class: "pl-t14a3eos"
});
const CarouselRow = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "CarouselRow",
  class: "pl-ce0aods"
});
const CarouselWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CarouselWrapper",
  class: "pl-c90vqqv"
});
const CarouselItemsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CarouselItemsContainer",
  class: "pl-crahr34",
  vars: {
    "crahr34-0": [({
      active,
      duration
    }) => active ? `transform ${duration}ms cubic-bezier(0.1,0.25,0.3,1)` : 'none'],
    "crahr34-1": [({
      active,
      amount
    }) => active ? `translateX(${amount}px)` : 'none']
  }
});
const CarouselFooter = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "CarouselFooter",
  class: "pl-c166i9n4"
});
const Container = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Container",
  class: "pl-c1gqq4v8"
});
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-c1wjnom7"
});

/**
 * TemplateCarouselSection component - DEPRECATED.
 * @module TemplateCarouselSection
 *
 * @param {object} props React props
 * @param {string} props._name The component's tracking name
 * @param {string} props.heading Heading text
 * @param {string} props.eyebrow Eyebrow text
 * @param {string} props.content Content text
 * @param {string} props.modalExitText The text displayed when exiting the modal
 * @param {array} props.modalPrimaryButtonText Array of child TabItems
 * @param {string} props.modalDisclaimerText The Modal's Disclaimer text
 * @param {string} props.entrySecondaryButtonText The Secondary Button's Text
 * @param {object} props.cta Call to Action button data
 * @param {string} props.verticalMargin Vertical Layout Spacing Values
 * @returns {React.ReactElement} TemplateCarouselSection component
 * @public
 */
function TemplateCarouselSection({
  _name,
  heading,
  eyebrow,
  category,
  modalExitText,
  modalPrimaryButtonText,
  modalDisclaimerText,
  entryPrimaryButtonText,
  entrySecondaryButtonText,
  cta,
  verticalMargin
}) {
  const tabDuration = 5000;
  const transitionDuration = 800;
  const scrollMethodBreakpoint = _patternLibraryUtils.size.tabletLg;
  const templates = category?.templates;
  const getCircularIndex = index => (templates.length + index % templates.length) % templates.length;
  const [visibleTemplates, setVisibleTemplates] = (0, _react.useState)(templates.slice(0, 3));
  const [focusIndex, setFocusIndex] = (0, _react.useState)(0);
  const [selected, setSelected] = (0, _react.useState)(null);
  const [scrollInstructions, setScrollInstructions] = (0, _react.useState)({
    active: false,
    pixelDir: 1,
    dir: 'next'
  });
  const [interacting, setInteracting] = (0, _react.useState)(false);
  const [interacted, setInteracted] = (0, _react.useState)(false);
  const slidesRef = (0, _react.useRef)();
  const nextRef = (0, _react.useRef)();
  const [slidesWidth, setSlidesWidth] = (0, _react.useState)(0);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  (0, _react.useEffect)(() => {
    setInteracted(selected !== null || interacted);
  }, [selected]);
  (0, _react.useEffect)(() => {
    const slider = slidesRef.current;
    setSlidesWidth(slider.clientWidth);
    if (width < scrollMethodBreakpoint) {
      setVisibleTemplates(category.templates);
      slidesRef.current.style.insetInlineEnd = 0;
    } else {
      slidesRef.current.style.insetInlineEnd = '25%';
    }
  }, [width]);
  (0, _react.useEffect)(() => {
    if (width >= scrollMethodBreakpoint) {
      const newVisible = [-1, 0, 1].map(offset => category.templates[getCircularIndex(focusIndex + offset)]);
      setVisibleTemplates(newVisible);
    }
  }, [focusIndex, width]);
  const toggleModalOpen = index => {
    setInteracted(true);
    if (index !== null) {
      setSelected(index);
    } else {
      setSelected(null);
    }
  };
  const changeFocus = index => {
    const nextIndex = getCircularIndex(index);
    setFocusIndex(nextIndex);
  };
  const focusPrev = e => {
    if (typeof document === 'undefined') return;
    if (e) setInteracted(true);
    if (interacting) return;
    setScrollInstructions({
      active: true,
      pixelDir: document.dir === 'rtl' ? 1 : -1,
      dir: 'prev'
    });
    setInteracting(true);
  };
  const focusNext = e => {
    if (typeof document === 'undefined') return;
    if (e) setInteracted(true);
    if (interacting) return;
    setScrollInstructions({
      active: true,
      pixelDir: document.dir === 'rtl' ? -1 : 1,
      dir: 'next'
    });
    setInteracting(true);
  };
  (0, _react.useEffect)(() => {
    if (!scrollInstructions.active || width < scrollMethodBreakpoint) return;
    const transitionArray = [...visibleTemplates];
    if (scrollInstructions.dir === 'next') {
      transitionArray.push(templates[getCircularIndex(focusIndex + 2)]);
    } else {
      slidesRef.current.style.insetInlineEnd = '75%';
      transitionArray.unshift(templates[getCircularIndex(focusIndex - 2)]);
    }
    setVisibleTemplates(transitionArray);
    const interval = setTimeout(() => {
      const newFocus = focusIndex + (scrollInstructions.dir === 'next' ? 1 : -1);
      changeFocus(newFocus);
      setScrollInstructions({
        ...scrollInstructions,
        active: false
      });
      slidesRef.current.style.insetInlineEnd = '25%';
      setInteracting(false);
    }, transitionDuration);
    return () => clearTimeout(interval);
  }, [scrollInstructions]);
  (0, _react.useEffect)(() => {
    if (width >= scrollMethodBreakpoint || width === 0 || interacted) {
      return;
    }
    const id = setInterval(() => {
      changeFocus(focusIndex + 1);
      nextRef?.current?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }, tabDuration);
    return () => clearInterval(id);
  }, [focusIndex, width, interacted]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    _name: _name,
    dataCy: "template-carousel-section",
    padding: "none",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(TemplateCarousel, null, /*#__PURE__*/_react.default.createElement(_index2.default, {
    heading: heading,
    eyebrow: eyebrow,
    headlineTag: eyebrow ? 'h3' : 'h2'
  }), /*#__PURE__*/_react.default.createElement(CarouselRow, null, /*#__PURE__*/_react.default.createElement(CarouselWrapper, {
    ref: slidesRef
  }, /*#__PURE__*/_react.default.createElement(CarouselItemsContainer, {
    active: scrollInstructions.active,
    amount: scrollInstructions.pixelDir * -slidesWidth,
    duration: transitionDuration,
    onMouseEnter: () => setInteracting(true),
    onMouseLeave: () => setInteracting(false),
    onTouchMove: () => setInteracted(true)
  }, visibleTemplates?.map((template, i) => /*#__PURE__*/_react.default.createElement(_TemplateItem.default, (0, _extends2.default)({
    key: i
  }, template, {
    primaryButtonText: entryPrimaryButtonText,
    secondaryButtonText: entrySecondaryButtonText,
    modalFn: () => toggleModalOpen(getCircularIndex(focusIndex - 1 + i)),
    ref: i === focusIndex ? nextRef : null
  })))), visibleTemplates?.map((template, i) => /*#__PURE__*/_react.default.createElement(_TemplateModal.default, {
    key: i,
    modalExitText: modalExitText,
    modalPrimaryButtonText: modalPrimaryButtonText,
    modalDisclaimerText: modalDisclaimerText,
    selectedTemplate: template,
    exitAction: () => toggleModalOpen(null),
    open: selected === getCircularIndex(focusIndex - 1 + i)
  })))), /*#__PURE__*/_react.default.createElement(CarouselFooter, null, cta && /*#__PURE__*/_react.default.createElement(CTAContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [cta]
  })), /*#__PURE__*/_react.default.createElement(_SlideControlButtons.default, {
    prevCallback: focusPrev,
    nextCallback: focusNext,
    timeout: tabDuration,
    disableAnimation: interacting || interacted,
    dataCy: 'template-carousel-controls'
  }))));
}
const categoryShape = {
  id: _propTypes.default.string,
  templates: _propTypes.default.arrayOf(_propTypes.default.shape(_TemplateItem.default.propTypes))
};
TemplateCarouselSection.propTypes = {
  _name: _propTypes.default.string,
  heading: _propTypes.default.string,
  eyebrow: _propTypes.default.string,
  category: _propTypes.default.shape(categoryShape),
  modalExitText: _propTypes.default.string,
  modalPrimaryButtonText: _propTypes.default.string,
  modalDisclaimerText: _propTypes.default.string,
  entryPrimaryButtonText: _propTypes.default.string,
  entrySecondaryButtonText: _propTypes.default.string,
  cta: _propTypes.default.shape(_merchButton.NSMerchButton.propTypes),
  ..._patternLibraryUtils.marginProps
};